export default function NewzAgentLogo({ height = 36, className = "", color = "#ffffff", accentColor = "#ef4444", showWordmark = true }) {
  const scale = height / 40;
  return (
    <span className={`newzagent-logo ${className}`} style={{ display: "inline-flex", alignItems: "center", gap: 8 * scale }}>
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ width: height * 0.8, height: height * 0.8, color }}>
        <rect x="2" y="4" width="20" height="14" rx="3" ry="3" />
        <polygon points="10 8 15 11 10 14 10 8" fill="currentColor" />
        <path d="M4 21h4l2-3 4 6 2-3h4" />
      </svg>
      {showWordmark ? (
        <span style={{ fontFamily: "'Montserrat', sans-serif", fontWeight: 900, fontSize: height * 0.6, letterSpacing: "-0.02em", color, lineHeight: 1, whiteSpace: "nowrap" }}>
          NewzAgent<span style={{ color: accentColor }}>.tv</span>
        </span>
      ) : null}
    </span>
  );
}
